import React, { useEffect, useState } from "react";
import {
  chatroomURL,
  getresumelistURL,
  showNotificationMsz,
  verifiyUserSession,
} from "../Components/Common/comman";
import { apihandler } from "../Components/Common/apicaller";
import {
  activeChatPopup,
  allChatMeesage,
  resumeList,
  socket,
  userLogin,
} from "../Components/Common/commonConst";
import { connect } from "react-redux";
import UnAuthRoute from "../ValidateFlow/UnAuthRoute";
import Loader from "../Components/Common/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import EmailRoutes from "./EmailRoutes";
import CandidateRoutes from "./CandidateRoutes";
import EmployerRoutes from "./EmployerRoutes";
import socketIOClient from "socket.io-client";
import { url } from "../Components/Common/configuration";

const ValidateFlow = (props) => {
  const [splashOpen, setSplashOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    validateUserData();
  }, []);
  useEffect(() => {
    if (props?.USERLOGIN?.user_id) {
      if (!props.SOCKET.connected) {
        const socketData = socketIOClient(url, {
          query: {
            userId: props?.USERLOGIN?.user_id,
          },
        });
        props.dispatch({
          type: socket,
          value: socketData,
        });
      }
    }
  }, [props?.USERLOGIN?.user_id]);

  const validateUserData = async (tokenfromDevice) => {
    let token = tokenfromDevice || "";
    let { data, status } = await apihandler({}, verifiyUserSession, "get");

    if (status === 1) {
      getResumeList(data.user_id);
      await props.dispatch({
        type: userLogin,
        value: data,
      });

      setSplashOpen(false);
    } else {
      setSplashOpen(false);
    }
  };
  const getResumeList = async (id) => {
    try {
      const { data, status } = await apihandler(
        {},
        getresumelistURL + id,

        "get"
      );
      if (status === 1) {
        await props.dispatch({
          type: resumeList,
          value: data,
        });
      }
    } catch (error) {
      console.log("resume catch error", error);
    }
  };
  const createChatRoom = async (receiverId) => {
    try {
      setIsLoading(true);
      if (props?.USERLOGIN?.user_id) {
        let payLoad = {
          userId: props.USERLOGIN.user_id,
          receiverId: receiverId,
        };
        const { data, status, message } = await apihandler(
          payLoad,
          chatroomURL,
          "post"
        );
        if (status === 1) {
          if (window.innerWidth <= 900) {
            window.location = "/user/chat?chatroom=" + data.id;
          } else {
            openMessagePopUp(data);
          }
        } else {
          showNotificationMsz(message, "danger");
        }
        setIsLoading(false);
      } else {
        window.location = "/login?redirect_url=" + window.location.href;
      }
    } catch (error) {
      setIsLoading(false);
      console.log("contact request catch error", error);
    }
  };
  const openMessagePopUp = async (row) => {
    let ACTIVECHATPOPUP = props.ACTIVECHATPOPUP;
    let selectPopUpIndex = await ACTIVECHATPOPUP.findIndex((event, index) => {
      return +event.id == +row.id;
    });
    if (selectPopUpIndex == -1) {
      ACTIVECHATPOPUP.push(row);
      selectPopUpIndex = ACTIVECHATPOPUP.length - 1;
    }
    if (Math.floor(window.innerWidth / 288) - ACTIVECHATPOPUP.length <= 0) {
      let selectedChatItem = ACTIVECHATPOPUP.splice(selectPopUpIndex, 1);
      ACTIVECHATPOPUP = ACTIVECHATPOPUP.concat(selectedChatItem);
    }
    props.dispatch({
      type: activeChatPopup,
      value: [...ACTIVECHATPOPUP],
    });
    setIsLoading(false);
  };
  if (splashOpen) {
    return <Loader isLoading={splashOpen} />;
  } else {
    return (
      <>
        {props?.USERLOGIN?.user_id ? (
          <>
            {props.USERLOGIN.email_verified === false && (
              <EmailRoutes
                {...props}
                navigate={navigate}
                location={location}
                validateUserData={validateUserData}
              />
            )}
            {props.USERLOGIN.email_verified === true &&
              props.USERLOGIN?.role === "candidate" && (
                <CandidateRoutes
                  {...props}
                  navigate={navigate}
                  location={location}
                  createChatRoom={createChatRoom}
                />
              )}
            {props.USERLOGIN.email_verified === true &&
              props.USERLOGIN?.role === "employer" && (
                <EmployerRoutes
                  {...props}
                  navigate={navigate}
                  location={location}
                  createChatRoom={createChatRoom}
                />
              )}
          </>
        ) : (
          <UnAuthRoute
            {...props}
            navigate={navigate}
            location={location}
            createChatRoom={createChatRoom}
          ></UnAuthRoute>
        )}
        <Loader isLoading={isLoading} />;
      </>
    );
  }
};
const mapStateToProps = function (state) {
  return {
    USERLOGIN: state[userLogin] || {},
    SOCKET: state[socket] || {},
    ALLCHATMESSAGE: state[allChatMeesage] || {},
    ACTIVECHATPOPUP: state[activeChatPopup] || [],
    RESUMELIST: state[resumeList] || [],
  };
};
export default connect(mapStateToProps)(ValidateFlow);
